import cx from "classnames";
import { ReactNode, useId } from "react";

import FiltersMobileTriggerButton from "components/Filters/MobileTriggerButton";
import ViewHeader from "components/ViewHeader";
import ViewHeaderTitle from "components/ViewHeader/Title";
import ViewHeaderWrapper from "components/ViewHeader/Wrapper";
import Box from "ds/components/Box";
import Callout from "ds/components/Callout";
import useDetectMobile from "hooks/useDetectMobile";

import { INTEGRATIONS_CALLOUT_STORAGE_KEY } from "../../constants";
import FiltersLayout from "./FiltersLayout";
import styles from "./styles.module.css";

type IntegrationsLayoutProps = {
  children: ReactNode;
  searchBar: ReactNode;
};

const IntegrationsLayout = ({ children, searchBar }: IntegrationsLayoutProps) => {
  const titleId = useId();
  const isMobile = useDetectMobile();

  return (
    <>
      <ViewHeader firstLevel>
        <ViewHeaderTitle>
          <Box justify="center" align="center" gap="medium">
            <ViewHeaderTitle id={titleId}>Integrations</ViewHeaderTitle>
          </Box>
        </ViewHeaderTitle>

        <ViewHeaderWrapper direction="row">
          {searchBar}
          <FiltersMobileTriggerButton />
        </ViewHeaderWrapper>
      </ViewHeader>
      <Callout
        title="Native integrations coming your way"
        variant="info"
        storageKey={INTEGRATIONS_CALLOUT_STORAGE_KEY}
      >
        Here you can find a list of all the built-in integrations, but Spacelift allows you to
        integrate with other platforms by using lifecycle hooks, webhooks, API keys and the ability
        to bring your own images.
      </Callout>
      <FiltersLayout titleId={titleId}>
        <Box className={cx(styles.integrationsWrapper, { [styles.mobile]: isMobile })}>
          {children}
        </Box>
      </FiltersLayout>
    </>
  );
};

export default IntegrationsLayout;
